module.exports = __webpack_public_path__ + "media/images/ajax-error-1930fe03b05c413f89f5e8d5266ae08f.jpg";